import React, { Component } from 'react'
function RepliesCount(props) {
  return (
    <span className="replies-count">
      {props.replyCount} {props.replyCount === 1 ? "Reply" : "Replies"}
    </span>
  )
}

export default RepliesCount;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/replies-count.es6